module.exports = __webpack_public_path__ + "fonts/VetoSansCond-BoldItalic.fb1b4d0b.woff2";